<table class="simple-table">
  <tr>
    <th>Status</th>
    <th>When</th>
  </tr>
  <tr>
    <td class="future">Future</td>
    <td>
      <div class="flex flex-row justify-start items-center auto-flex">
        <mat-form-field appearance="outline" class="width140 p-r-10">
          <mat-select [(ngModel)]="statusSettings.futureInDays" data-cy="Future"
                      (selectionChange)="updateStatusSettings(statusSettings)">
            <mat-option *ngFor="let number of numbers" [value]="number">
              {{number}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span>
          days before Due Date
        </span>
      </div>

    </td>
  </tr>
  <tr>
    <td class="upcoming">Upcoming</td>
    <td>
      <div class="flex flex-row justify-start items-center auto-flex">
        <mat-form-field appearance="outline" class="width140 p-r-10">
          <mat-select [(ngModel)]="statusSettings.upcomingInDays" data-cy="Upcoming"
                      (selectionChange)="updateStatusSettings(statusSettings)">
            <mat-option *ngFor="let number of numbers" [value]="number">
              {{number}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span>
          days before Due Date
        </span>
      </div>
    </td>
  </tr>
  <tr>
    <td class="due-now">Due Now</td>
    <td>
      <div class="flex flex-row justify-start items-center auto-flex">
        <mat-form-field appearance="outline" class="width140 p-r-10">
          <mat-select [(ngModel)]="statusSettings.dueNowInDays" data-cy="Due Now"
                      (selectionChange)="updateStatusSettings(statusSettings)">
            <mat-option *ngFor="let number of numbers" [value]="number">
              {{number}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span> days before Due Date</span>
      </div>

    </td>
  </tr>
  <tr>
    <td class="overdue">Overdue</td>
    <td>Task Due Date in the past</td>
  </tr>
  <tr>
    <td class="complete">Completed</td>
    <td>Task has been completed</td>
  </tr>
  <tr>
    <td class="na">N/A</td>
    <td>Task has not been assigned a Due Date</td>
  </tr>

</table>
